import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { KeyValue } from '@angular/common';
import {
  IApiResponse,
  IFilterPaginationDto,
  IProductBalanceDto,
  IProductFeeDto,
  IProductInfoCouponDto,
  IProductInfoDto,
  IProductOrderDto,
  IProductOrderSummaryDto,
  IProductReceiptDto,
  IProductReedemDto,
  IProductReportDto,
  IProductReportFilterDto,
  IProductReviewDto,
} from '../models';

@Injectable()
export class GiftcardService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getProducts(id: number): Observable<KeyValue<number, string>[]> {
    return this.get(`admin/giftcard/${id}`);
  }

  public getProductOrder(id: number): Observable<IProductOrderDto> {
    return this.get(`admin/giftcard/order/${id}`);
  }

  public getProductList(
    id: number,
    model: IFilterPaginationDto
  ): Observable<IProductInfoDto[]> {
    return this.post(`admin/giftcard/list/${id}`, model);
  }

  public getProductFeeList(
    model: IFilterPaginationDto
  ): Observable<IProductFeeDto[]> {
    return this.post(`admin/giftcard/fee/list`, model);
  }

  public getProductCouponList(
    model: IFilterPaginationDto
  ): Observable<IProductInfoCouponDto[]> {
    return this.post(`admin/giftcard/coupon/list`, model);
  }

  public getProductOrderList(
    id: number,
    model: IFilterPaginationDto
  ): Observable<IProductOrderSummaryDto[]> {
    return this.post(`admin/giftcard/order/list/${id}`, model);
  }

  public saveProduct(
    model: IProductInfoDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/giftcard`, model);
  }

  public saveProductFee(
    model: IProductFeeDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/giftcard/fee`, model);
  }

  public saveProductCoupon(
    model: IProductInfoCouponDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/giftcard/coupon`, model);
  }

  public changeProductStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/giftcard/${id}`, null);
  }

  public changeProductFeeStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/giftcard/fee/${id}`, null);
  }

  public changeProductCouponStatus(
    id: number
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/giftcard/coupon/${id}`, null);
  }

  public deleteProduct(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/giftcard/${id}`);
  }

  public deleteProductFee(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/giftcard/fee/${id}`);
  }

  public deleteProductCoupon(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/giftcard/coupon/${id}`);
  }

  public buyProduct(
    model: IProductReviewDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/giftcard/sell`, model);
  }

  public getProductBalance(
    model: IProductBalanceDto
  ): Observable<IApiResponse<IProductBalanceDto>> {
    return this.post(`admin/giftcard/balance`, model);
  }

  public redeemProduct(
    model: IProductReedemDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/giftcard/redeem`, model);
  }

  public productReport(
    model: IProductReportFilterDto
  ): Observable<IProductReportDto> {
    return this.post(`admin/giftcard/report`, model);
  }

  public productReceipt(
    model: KeyValue<string, number>
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/giftcard/receipt`, model);
  }

  public productMannualReceipt(
    model: IProductReceiptDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/giftcard/mannualReceipt`, model);
  }
}
